import { db } from "@/firebase";
import { useUserStore } from "@/store";
import type { Account } from "@aircap/common/account";
import type { SupervisorOrgGroup } from "@aircap/common/supervisorOrg";
import { supervisorOrgGroupsFullPath } from "@aircap/common/supervisorOrg";
import { addDoc, collection, doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { ref } from "vue";

export const useGroup = () => {
  const user = useUserStore();

  const addGroup = async ({ name, accountId }: { name: string; accountId: string }) => {
    if (!user.supervisorOrgId) throw new Error("Supervisor org ID is required");

    const coll = collection<SupervisorOrgGroup>(
      db,
      supervisorOrgGroupsFullPath(user.supervisorOrgId),
    );
    const newRef = await addDoc(coll, { name, createdAt: serverTimestamp() });

    const account = doc<Account>(db, `accounts/${accountId}`);
    await updateDoc(account, { groupId: newRef.id });

    return newRef.id;
  };

  const setGroup = async ({
    groupId,
    accountId,
  }: {
    groupId?: string | null;
    accountId: string;
  }) => {
    const account = doc<Account>(db, `accounts/${accountId}`);
    await updateDoc(account, { groupId: groupId ?? null });
  };

  const saveGroup = async ({
    id,
    name,
    accountId,
  }: {
    id?: string | null;
    name?: string | null;
    accountId: string;
  }) => {
    if (id === "new" && name) {
      await addGroup({ name, accountId });
    } else {
      await setGroup({ groupId: id, accountId });
    }
  };

  const newGroupName = ref<string | null>(null);

  return { saveGroup, newGroupName };
};
